/*
  Dlunaas · Documento de identidad en el carrito.

  El tema reconstruye el carrito con innerHTML en cada cambio (ver
  Shopify.theme.ajaxCart), así que todo va delegado en `document`: no se puede
  enganchar nada al nodo en el momento del render porque desaparece.

  El formulario del carrito hace POST nativo a /cart, y los campos se llaman
  attributes[...], de modo que Shopify guarda el dato solo con enviar el
  formulario. El guardado por ajax es para que el valor sobreviva a los
  re-renders (cambiar cantidades, quitar líneas) y para el botón "Comprar
  ahora" de la ficha, que no pasa por este formulario.
*/
(function () {
  'use strict';

  var ATTR_TIPO = 'Tipo de documento';
  var ATTR_NUM = 'Número de documento';

  var REGLAS = {
    CC:        { re: /^\d{5,12}$/,            msg: 'La cédula debe tener entre 5 y 12 dígitos.' },
    CE:        { re: /^\d{5,12}$/,            msg: 'La cédula de extranjería debe tener entre 5 y 12 dígitos.' },
    NIT:       { re: /^\d{9,10}(-?\d)?$/,     msg: 'El NIT debe tener 9 o 10 dígitos, con o sin dígito de verificación.' },
    Pasaporte: { re: /^[A-Za-z0-9]{5,20}$/,   msg: 'El pasaporte debe tener entre 5 y 20 letras o números.' }
  };

  var MSG_VACIO = 'Escriba su número de documento para continuar.';

  // Recibe la caja [data-dl-doc] y devuelve sus tres partes.
  function partes(caja) {
    if (!caja) return null;
    var tipo = caja.querySelector('[data-dl-doc-tipo]');
    var num = caja.querySelector('[data-dl-doc-num]');
    if (!tipo || !num) return null;
    return { caja: caja, tipo: tipo, num: num, error: caja.querySelector('[data-dl-doc-error]') };
  }

  // Desde cualquier nodo de dentro.
  function partesDesde(el) {
    return partes(el.closest('[data-dl-doc]'));
  }

  // Devuelve null si está bien, o el mensaje de error.
  function revisar(tipo, valor) {
    var v = (valor || '').trim();
    if (!v) return MSG_VACIO;
    var regla = REGLAS[tipo] || REGLAS.CC;
    return regla.re.test(v) ? null : regla.msg;
  }

  function pintar(c, fallo, mostrar) {
    if (!c) return;
    c.caja.classList.toggle('is-error', !!fallo && mostrar);
    if (c.num) c.num.setAttribute('aria-invalid', fallo ? 'true' : 'false');
    if (c.error) {
      if (fallo && mostrar) {
        c.error.textContent = fallo;
        c.error.hidden = false;
      } else {
        c.error.hidden = true;
        c.error.textContent = '';
      }
    }
  }

  // --- Guardado en los atributos del carrito ---
  var pendiente = null;

  function guardar(tipo, numero) {
    var datos = {};
    datos[ATTR_TIPO] = tipo;
    datos[ATTR_NUM] = (numero || '').trim();

    if (window.Shopify && Shopify.theme && Shopify.theme.cart && Shopify.theme.cart.updateAttributes) {
      return Shopify.theme.cart.updateAttributes(datos).catch(function () {});
    }
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: datos })
    }).catch(function () {});
  }

  function guardarDespacio(tipo, numero) {
    clearTimeout(pendiente);
    pendiente = setTimeout(function () { guardar(tipo, numero); }, 400);
  }

  // --- Escritura y cambio de tipo ---
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-dl-doc-num]')) return;
    var c = partesDesde(e.target);
    if (!c) return;
    // Mientras escribe solo se limpia el error; no se regaña a media palabra.
    if (!c.caja.classList.contains('is-error')) return;
    pintar(c, revisar(c.tipo.value, c.num.value), true);
  });

  document.addEventListener('change', function (e) {
    var esNum = e.target.matches('[data-dl-doc-num]');
    var esTipo = e.target.matches('[data-dl-doc-tipo]');
    if (!esNum && !esTipo) return;

    var c = partesDesde(e.target);
    if (!c) return;

    // El pasaporte admite letras; el resto es numérico.
    if (c.num) c.num.setAttribute('inputmode', c.tipo.value === 'Pasaporte' ? 'text' : 'numeric');

    var fallo = revisar(c.tipo.value, c.num.value);
    pintar(c, fallo, !!c.num.value.trim());
    guardarDespacio(c.tipo.value, c.num.value);
  });

  /*
    El input lleva `required` como red de seguridad si el JS no carga. Pero la
    validación nativa corta el envío antes del evento submit, y enseña su propio
    globo en el idioma del navegador. Interceptando `invalid` se silencia ese
    globo y se pinta el mensaje propio.
  */
  document.addEventListener('invalid', function (e) {
    if (!e.target.matches('[data-dl-doc-num]')) return;
    e.preventDefault();
    var c = partesDesde(e.target);
    if (!c) return;
    pintar(c, revisar(c.tipo.value, c.num.value) || MSG_VACIO, true);
    try {
      c.num.focus({ preventScroll: true });
      c.caja.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (err) {
      c.num.focus();
    }
  }, true);

  // --- Bloqueo del paso a pagar ---
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('js-cart-form')) return;

    var c = partes(form.querySelector('[data-dl-doc]'));
    if (!c) return;

    var fallo = revisar(c.tipo.value, c.num.value);
    if (!fallo) return;

    e.preventDefault();
    pintar(c, fallo, true);
    try {
      c.num.focus({ preventScroll: true });
      c.caja.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (err) {
      c.num.focus();
    }
  }, true);

  /*
    Para el botón "Comprar ahora" de la ficha, que se salta el carrito.
    Resuelve a true si el carrito ya tiene un documento válido guardado.
  */
  window.dlDocumentoEnCarrito = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        var a = carrito.attributes || {};
        return !revisar(a[ATTR_TIPO] || 'CC', a[ATTR_NUM]);
      })
      .catch(function () { return false; });
  };
})();
